function isOverflowing(element, container = document.body) {
	const containerRect = container.getBoundingClientRect();
	const containerTop = containerRect.top + window.scrollY;
	const elementRect = element.getBoundingClientRect();
	const elementTop = elementRect.top + window.scrollY;

	if (containerTop + containerRect.height < elementTop + elementRect.height) {
		return 'bottom';
	}

	if (containerTop > elementTop || elementRect.y <= 0) {
		return 'top';
	}

	return null;
}
